import { request } from '../boot/request';

const getStoreInfo = params => {
  params = params || {};
  return request({
    url: '/store',
    method: 'GET',
    params,
  });
};
const getReadyOrder = params => {
  params = params || {};
  return request({
    url: '/readyOrderCount',
    method: 'GET',
    params,
  });
};

const getCoverPage = params => {
  params = params || {};
  return request({
    url: '/storeHomePage',
    method: 'GET',
    params,
  });
};

const getNearestChainStores = params => {
  params = params || {};
  return request({
    url: '/nearestChainStores',
    method: 'POST',
    data: params,
  });
};

const getVouchers = params => request({
  url: '/storeVoucherList',
  method: 'POST'
})

const isUserRegisterApp = () => request({
  url: '/ifHoregoAppRegister',
  method: 'GET'
})

export {
  getStoreInfo, getReadyOrder, getCoverPage, getNearestChainStores, getVouchers, isUserRegisterApp
};
